// Block picker on the berry Receive form: once a variety is chosen, list only
// the blocks that grow it, plus blocks with no variety recorded. When nothing
// matches, list every block and flag it so the form can say why.
export interface VarietyBlock { variety: string | null }

const norm = (s: string | null | undefined) => (s ?? '').trim().toLowerCase()

export function blocksForVariety<T extends VarietyBlock>(
  blocks: T[], variety: string,
): { blocks: T[]; noMatch: boolean } {
  const want = norm(variety)
  if (!want) return { blocks, noMatch: false }
  if (!blocks.some(b => norm(b.variety) === want)) return { blocks, noMatch: blocks.length > 0 }
  return { blocks: blocks.filter(b => !norm(b.variety) || norm(b.variety) === want), noMatch: false }
}
